/**
 * Стандартный onClick кнопки футера окна — алиас «modal-hide»: закрыть окно.
 *
 * Плагин базового слоя open-modal-window.js (1 файл — 1 функция). Вызывается с аргументами
 * (button, config): button — нажатая кнопка (jQuery), здесь не используется; config — опции окна
 * (с уже разрешёнными url/title/modal).
 */
window.openModalWindowFunctions["modal-hide"] = function (element, config) {
    config.modal.modal("hide");
};
